import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';
import { Regulamin } from '../../../../../shared/models/regulamin';
import { RulesApi } from '../../../../../shared/services/api/rules.api';
import { HttpResponseService } from '../../../../../core/services/http-error-response.service';

export const ruleEditResolver: ResolveFn<Regulamin> = (
  route,
): Observable<Regulamin> => {
  const api = inject(RulesApi);
  const httpResponseService = inject(HttpResponseService);
  const idParam = route.paramMap.get('id');
  const parsedId = idParam ? Number(idParam) : NaN;

  if (!Number.isFinite(parsedId)) {
    throw new Error('Invalid rule id.');
  }

  return api.getRuleById$(parsedId).pipe(
    catchError((err) => {
      httpResponseService.showErrorMessage(
        err,
        'Wystąpił błąd podczas pobierania regulaminu.',
      );
      return EMPTY;
    }),
  );
};
